var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"wd_file"},[_c('wd-link',{attrs:{"align":"right"}},[_vm._v(_vm._s(_vm.$t('uiKit.file.caption')))]),_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }